<template>
  <div class="uara-activity-view">
    <el-form ref="form" :model="form" label-width="140px" size="small">
      <div class="white-container">
        <div style="margin-bottom: 16px">基础信息</div>
        <el-form-item label="姓名：" style="width: 300px">{{ form.name }}</el-form-item>
        <el-form-item label="状态：" style="width: 300px">
          <span v-if="form.status === 0" class="status-tag status-pending">待审核</span>
          <span v-else-if="form.status === 1" class="status-tag status-passed">已通过</span>
          <span v-else-if="form.status === 2" class="status-tag status-rejected">拒绝</span>
        </el-form-item>
        <el-form-item label="联系方式：" style="width: 300px">{{ form.contact }}</el-form-item>
        <el-form-item label="所在地区：" style="width: 300px">{{ form.region }}</el-form-item>
        <el-form-item label="身份：" style="width: 300px">{{ identityAnswer }}</el-form-item>
      </div>

      <div
        v-for="(item) in filteredAnswers"
        :key="item.questionId"
        class="white-container"
        style="margin-top: 16px"
      >
        <div style="margin-bottom: 30px; font-size: 16px">{{ item.questionTitle }}</div>
        <div v-for="opt in item.options" :key="opt.optionId" style="margin-bottom: 4px; margin-left: 0px; font-size: 14px">
          <span>{{ opt.optionContent }}</span>
          <span v-if="opt.textAnswer" style="color: #999; margin-left: 8px">{{ opt.textAnswer }}</span>
        </div>
      </div>

      <div v-if="form.status === 2 && form.rejectReason" class="white-container" style="margin-top: 16px">
        <div style="margin-bottom: 16px; font-size: 16px">拒绝理由</div>
        <div style="font-size: 14px">{{ form.rejectReason }}</div>
      </div>

      <div style="text-align: center; margin-top: 30px">
        <template v-if="form.status === 0">
          <el-button style="background: #DC0019; color: #fff; border-color: #DC0019" @click="showRejectDialog">拒绝</el-button>
          <el-button type="primary" @click="handleApprove">通过</el-button>
        </template>
        <el-button v-else style="background: #000; color: #fff; border-color: #000" @click="goBack">返回</el-button>
      </div>
    </el-form>

    <el-dialog title="拒绝理由" :visible.sync="rejectDialogVisible" width="400px" :close-on-click-modal="false" custom-class="reject-dialog">
      <el-input v-model="rejectReason" type="textarea" :rows="4" placeholder="请输入驳回理由" />
      <div slot="footer" style="text-align: center">
        <el-button style="background: #DC0019; color: #fff; border-color: #DC0019" :loading="rejectLoading" @click="handleReject">拒绝</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { clubApplyDetail, approvalClubApply } from "@/api/rugby";

export default {
  name: "RugbyReviewEdit",
  data() {
    return {
      form: {},
      rejectDialogVisible: false,
      rejectReason: "",
      rejectLoading: false,
    };
  },
  computed: {
    identityAnswer() {
      const q = (this.form.answers || []).find(a => a.questionTitle === "你的当前身份");
      if (!q || !q.options || !q.options.length) return "";
      return q.options.map(o => o.optionContent).join("、");
    },
    filteredAnswers() {
      return (this.form.answers || []).filter(a => a.questionTitle !== "你的当前身份");
    },
  },
  created() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const { id } = this.$route.query;
      if (!id) return;
      const res = await clubApplyDetail(id);
      this.form = res;
    },
    async handleApprove() {
      await approvalClubApply({
        applicationId: this.form.id,
        status: 1,
      });
      this.$message.success("已通过");
      this.getDetail();
    },
    showRejectDialog() {
      this.rejectReason = "";
      this.rejectDialogVisible = true;
    },
    async handleReject() {
      if (!this.rejectReason.trim()) {
        this.$message.warning("请输入驳回理由");
        return;
      }
      this.rejectLoading = true;
      try {
        await approvalClubApply({
          applicationId: this.form.id,
          status: 2,
          rejectReason: this.rejectReason.trim(),
        });
        this.$message.success("已拒绝");
        this.rejectDialogVisible = false;
        this.getDetail();
      } finally {
        this.rejectLoading = false;
      }
    },
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.el-button {
  width: 120px;
  height: 50px;
}
.status-tag {
  display: inline-block;
  width: 100px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  border-radius: 4px;
  font-size: 12px;
}
.status-pending {
  color: #EA9921;
  background: #EA99211A;
  border: 1px solid #EA9921B2;
}
.status-passed {
  color: #60AC56;
  background: #60AC561A;
  border: 1px solid #60AC56B2;
}
.status-rejected {
  color: #DC0019;
  background: #DC00191A;
  border: 1px solid #DC0019B2;
}
</style>

<style>
.reject-dialog .el-dialog__header {
  background: #000;
}
.reject-dialog .el-dialog__title {
  color: #fff;
}
.reject-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}
</style>
